import { ActionBase } from '../../../core/store/action/ActionBase';

export const CANCEL_JOB_SUBMISSION = '[Submission] Cancel Job Submission';

export class CancelJobSubmissionAction implements ActionBase {
  readonly identifier = new Date().getTime().toString();
  readonly type = CANCEL_JOB_SUBMISSION;

  constructor(public payload: { key: string, jobKey: string }) {}
}



// WEBPACK FOOTER //
// ./src/app/submission/store/actions/CancelJobSubmissionAction.ts